import EN from '../../EN.json';

export const isEmpty = obj => {
  for (const key in obj) {
    if (obj[key] !== null && obj[key] != '') return false;
  }
  return true;
};

export const isSequentialOrRepeatable = value => {
  if(!value){
    return true;
  };
  let isSequential = false;
  value.split('').forEach((_val, index) => {
    const subStr = value.substr(index, value.length);
    for (let i = 3, len = subStr.length; i < len; i += 1) {
      if (
        subStr[i - 3].charCodeAt(0) === subStr[i - 2].charCodeAt(0) - 1 && subStr[i - 2].charCodeAt(0) === subStr[i - 1].charCodeAt(0) - 1 &&
          subStr[i - 1].charCodeAt(0) === subStr[i].charCodeAt(0) - 1
      ) {
        isSequential = true;
      }
    }
  });
  return !(/(.)\1{2,}/g.test(value) || isSequential);
  
};
export const getLocale = () => {
  // localStorage.getItem('LOCALE');
  return EN;
};

export const setLocale = (locale) => {
  // localStorage.setItem('LOCALE', locale);
};
